const CACHE_HYDRATION_TIMEOUT_MS = 10_000;

const { promise, resolve, reject } = Promise.withResolvers<void>();

// A Promise settles only once – whichever of onCacheHydrated() or the timeout fires first wins; the other becomes a no-op.
setTimeout(() => {
  reject(
    new Error(
      `cacheHydratedPromise timed out after ${CACHE_HYDRATION_TIMEOUT_MS} ms – IndexedDB may be unavailable.`,
    ),
  );
}, CACHE_HYDRATION_TIMEOUT_MS);

export const cacheHydratedPromise = promise;

export function onCacheHydrated() {
  console.debug("Cache hydrated – IndexedDB ready");
  resolve();
}
